export const PROJECTS_SET_PROJECTS = 'PROJECTS_SET_PROJECTS';
export const PROJECTS_SET_SELECTED_PROJECT = 'PROJECTS_SET_SELECTED_PROJECT';
